export {scrollToTop};

/**
 * https://stackoverflow.com/questions/21474678/scrolltop-animation-without-jquery
 * @param scrollDuration; ms
 */
function _scrollToTop(scrollDuration) {
  const   scrollHeight = window.scrollY,
    scrollStep = Math.PI / ( scrollDuration / 15 ),
    cosParameter = scrollHeight / 2;
  var     scrollCount = 0,
    scrollMargin,
    scrollInterval = setInterval( function() {
      if ( window.scrollY != 0 ) {
        scrollCount = scrollCount + 1;
        scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
        window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
      }
      else clearInterval(scrollInterval);
    }, 15 );
}

async function scrollToTop(elements) {
  if (elements.length > 0) {
    elements.forEach( el => {
      el.addEventListener('click', (event) => {
        _scrollToTop(el.dataset.duration);
        event.preventDefault();
      });
    });
  }
}
